import React from 'react';
import { FaSearch } from 'react-icons/fa';

// Icon-prefixed search input, styled to match the existing Product Master
// search bar exactly (that markup is the app's de facto search-box standard).
export const SearchBox = ({ style, inputStyle, ...inputProps }) => (
  <div className="list-toolbar-search" style={{ flex: '1 1 200px', minWidth: '160px', position: 'relative', ...style }}>
    <FaSearch style={{ position: 'absolute', left: '10px', top: '50%', transform: 'translateY(-50%)', color: 'var(--text-light)' }} />
    <input
      type="text"
      className="form-control"
      autoComplete="off"
      spellCheck={false}
      {...inputProps}
      style={{ paddingLeft: '35px', ...inputStyle }}
    />
  </div>
);

// Labeled filter dropdown, styled to match the Dosage Form / Equipment Train
// filters on Product Master.
export const FilterSelect = ({ label, selectStyle, children, ...selectProps }) => (
  <div className="list-toolbar-filter" style={{ display: 'flex', alignItems: 'center', gap: '6px', flex: '0 0 auto' }}>
    {label && (
      <label className="list-toolbar-filter-label" style={{ margin: 0, whiteSpace: 'nowrap', fontWeight: 600, fontSize: 'var(--fs-md)', color: 'var(--text-secondary)' }}>
        {label}
      </label>
    )}
    <select className="form-control list-toolbar-filter-select" {...selectProps} style={{ minWidth: '140px', width: 'auto', ...selectStyle }}>
      {children}
    </select>
  </div>
);
